export const DEFAULT_LIBRARY = "default";
